import { toUnicode, toASCII } from 'punycode.js';
import { Base } from '../../Base/Base';
import { Tld } from './Tld';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "domainName": "Fqdn-domainName_lyYW3"
};
function truncate(fqdn, max) {
  let newString = fqdn;
  if (fqdn.length > max + 2) {
    const middle = max / 2;
    newString = [fqdn.slice(0, middle), ' … ', fqdn.slice(fqdn.length - middle, fqdn.length)].join('');
  }
  return newString;
}
function extractTldFromDomain(inputFqdn, maxLength) {
  let fqdn = inputFqdn;
  let aLabel = inputFqdn;
  try {
    fqdn = toUnicode(inputFqdn);
    aLabel = toASCII(inputFqdn);
  } catch (e) {}
  const split = fqdn.split('.');
  let label = fqdn;
  let tld;
  try {
    const decodedBase = toUnicode(split.shift() || '');
    const decodedTld = toUnicode(split.join('.'));
    if (decodedBase || decodedTld) {
      label = decodedBase;
      tld = decodedTld;
    }
  } catch (e) {}
  try {
    if (maxLength) label = truncate(label, maxLength);
  } catch (e) {}
  const formatted = tld ? `${label}.${tld}` : label;
  const title = formatted !== aLabel ? aLabel : undefined;
  return {
    label,
    tld,
    formatted,
    title
  };
}
function Fqdn({
  children = '',
  maxLength = 63,
  tagName = 'span',
  weight = 'semibold',
  ...extraProps
}) {
  const {
    label,
    tld,
    title
  } = extractTldFromDomain(children, maxLength);
  const tldProps = {};
  if (extraProps.color) tldProps.color = extraProps.color;
  if (weight && weight !== 'semibold') tldProps.weight = weight;
  return /*#__PURE__*/_jsxs(Base, {
    tagName: tagName,
    title: title,
    weight: weight,
    ...extraProps,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.domainName,
      children: truncate(label, maxLength)
    }), tld && /*#__PURE__*/_jsx(Tld, {
      ...tldProps,
      children: tld
    })]
  });
}
Fqdn.displayName = 'Fqdn';
export { Fqdn };